// extracted by mini-css-extract-plugin
export default {"list":"TimeTabs_list__ej6rQ","modal":"TimeTabs_modal__PpGrv"};